module.exports = __webpack_public_path__ + "static/media/email.f7e3bead.svg";